import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopAppointmentStatusList extends Layout {
    sourceStopWithDetention: DataSource;
    tableStopApptStatusList: Table;
}
